module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAFKADAAQAAAABAAAAFAAAAACy3fD9AAAA8UlEQVQ4EWNgGAWUhgAjIQMmzTsk+u/P74k8TJw5KSlW7wipZ8KnAGrYfob//yO//Pu2d86cY0L41IPkcBqIZJg2IyPjf4b/DAbEGIrVQGTDGBgZrzIyMxoyMDDeJMZQDAPRDWPn4HDKS3a6yMnA6kiMoSiRgs2wzDjrV7BwmznzkOR3ht/7GRj+qzMwMlzgYeJyRo8ouIGEDCPWULCX0Q1jYmF1RHYZzDAQnZ5u9xyf9xmxGZaXZPca2RBsbFzeZwIm2vXAdKYNik2Qy4gxDIdL14LEQV7+BMTHSTEMpBEEYN5nZGQ4DUwBIHNGwWAMAQBaxLMUa6mH8AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/QuickSales/up.png
// module id = Kwef
// module chunks = 19